/**
 * Generated by `./scripts/prebuild/generate-icons-experimental.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
/**
 * @deprecated The name Experimental__IconSearch is deprecated and will be archived soon. Use IconSearch instead.
 */

export function Experimental__IconSearch(props) {
  var iconList = [{
    size: 16,
    svgContent: "<path d='M11.618 11.532A5.589 5.589 0 0013.22 7.61a5.61 5.61 0 10-5.61 5.61 5.58 5.58 0 003.246-1.04l2.912 3.409.76-.649-2.91-3.408zm-4.008.688C5.068 12.22 3 10.152 3 7.61S5.068 3 7.61 3s4.61 2.068 4.61 4.61-2.068 4.61-4.61 4.61z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M16.387 16.623A8.47 8.47 0 0019 10.5a8.5 8.5 0 10-8.5 8.5 8.454 8.454 0 005.125-1.73l4.401 5.153.76-.649-4.399-5.151zM10.5 18C6.364 18 3 14.636 3 10.5S6.364 3 10.5 3 18 6.364 18 10.5 14.636 18 10.5 18z'/>"
  }, {
    size: 32,
    svgContent: "<path d='M22.527 22.006A10.953 10.953 0 0026 14c0-6.075-4.925-11-11-11S4 7.925 4 14s4.925 11 11 11c2.556 0 4.901-.879 6.769-2.342l6.146 7.196.76-.649-6.148-7.199zM15 24C9.486 24 5 19.514 5 14S9.486 4 15 4s10 4.486 10 10-4.485 10-10 10z'/>"
  }, {
    size: 48,
    svgContent: "<path d='M34.774 33.245C37.99 30.152 40 25.815 40 21c0-9.389-7.611-17-17-17S6 11.611 6 21s7.611 17 17 17c3.854 0 7.397-1.298 10.249-3.46l8.801 10.305 1.521-1.299-8.797-10.301zM23 36c-8.271 0-15-6.729-15-15S14.729 6 23 6s15 6.729 15 15-6.729 15-15 15z'/>"
  }, {
    size: 64,
    svgContent: "<path d='M44.864 44.931C49.253 40.825 52 34.985 52 28.5 52 16.073 41.926 6 29.5 6S7 16.073 7 28.5C7 40.926 17.074 51 29.5 51a22.392 22.392 0 0013.844-4.77l11.854 13.879 1.521-1.299-11.855-13.879zM29.5 49C18.197 49 9 39.804 9 28.5S18.197 8 29.5 8 50 17.197 50 28.5 40.804 49 29.5 49z'/>"
  }];
  var iconListRedraw = [{
    size: 16,
    svgContent: "<path d='M7 1.75a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5zM.25 7a6.75 6.75 0 1112.096 4.12l3.184 3.185a.75.75 0 11-1.06 1.06L11.304 12.2A6.75 6.75 0 01.25 7z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M10.533 1.279c-5.18 0-9.407 4.14-9.407 9.279s4.226 9.279 9.407 9.279c2.234 0 4.29-.77 5.907-2.058l4.353 4.353a1 1 0 101.414-1.414l-4.344-4.344a9.157 9.157 0 002.077-5.816c0-5.14-4.226-9.28-9.407-9.28zm-7.407 9.279c0-4.006 3.302-7.28 7.407-7.28s7.407 3.274 7.407 7.28-3.302 7.279-7.407 7.279-7.407-3.273-7.407-7.28z'/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.deprecated ? iconListFallback : iconListRedraw, props.iconSize || 24);

  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };

  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };

  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
export default Experimental__IconSearch;